export default __webpack_public_path__ + "static/media/BrittScott.71a4b3dd.svg";